import React from "react";
import { Form } from "semantic-ui-react";
import { useExtLabels } from './extLabels'

const Address = ({ model, errors = {}, onChange, disabled }) => {
    const l = useExtLabels()

    const handleChange = target => onChange({ ...model, [target.name]: target.value });

    return (
        <React.Fragment>
            <Form.Input
                disabled={disabled}
                label={l("Adres")}
                name="street"
                value={model.street}
                onChange={({ target }) => handleChange(target)}
                required
                error={!!errors.street}
            />
            <Form.Group>
                <Form.Input
                    disabled={disabled}
                    label={l("Kod pocztowy")}
                    width="5"
                    name="postalCode"
                    value={model.postalCode}
                    onChange={({ target }) => handleChange(target)}
                    required
                    pattern="^\d{2}-\d{3}$"
                    error={!!errors.postalCode}
                />
                <Form.Input
                    disabled={disabled}
                    label={l("Miasto")}
                    width="11"
                    name="city"
                    value={model.city}
                    onChange={({ target }) => handleChange(target)}
                    required
                    error={!!errors.city}
                />
            </Form.Group>
        </React.Fragment>
    );
};

export default Address;